import React from 'react';
import styled from 'styled-components';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { black, blue, grey } from '../assets/ui/colors';

const BreadcrumbsContainer = styled.div`
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: 0.31px;
    display: flex;
    margin-bottom: 24px;
    align-items: center;
    max-width: calc(100vw - 48px);
    @media (max-width: 600px) {
        font-size: 16px;
        line-height: 20px;
    }
`;

const BreadcrumbsItem = styled.div`
    display: flex;
    align-items: center;
`;

const BreadcrumbsItemArrow = styled.div`
    margin: 0 16px;
    color: ${grey};
    display: flex;
`;

const BreadcrumbsItemCurrent = styled.div`
    color: ${blue};
    margin-right: 4px;
`;

const BreadcrumbsSubLabel = styled.div`
    font-size: 16px;
    font-style: normal;
    font-weight: normal;
    line-height: 19px;
    letter-spacing: 0.15px;
    color: ${black};
    align-self: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const Breadcrumbs = ({
    pathArr,
    payType
}) => {

    if (!pathArr || !pathArr.length) {
        return <div />
    }

    return (
        <BreadcrumbsContainer>
            {pathArr.map((item, index) => {
                if (index < pathArr.length - 1)
                    return (
                        <BreadcrumbsItem key={`${index}${item.label}`}>
                            {item.label}
                            <BreadcrumbsItemArrow><ChevronRightIcon /></BreadcrumbsItemArrow>
                        </BreadcrumbsItem>
                    )
            })}
            <BreadcrumbsItemCurrent>
                {pathArr[pathArr.length - 1].label}
            </BreadcrumbsItemCurrent>
            {payType &&
                <BreadcrumbsSubLabel>
                    {`  – ${payType}`}
                </BreadcrumbsSubLabel>
            }
        </BreadcrumbsContainer>
    )
}

export default Breadcrumbs;
